var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.004,
    height: 20.003,
    viewBox: "0 0 20.004 20.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49979",
    "data-name": "Group 49979",
    transform: "translate(22630 8070)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_8674956_ic_fluent_info_regular_icon",
    "data-name": "8674956_ic_fluent_info_regular_icon",
    d: "M12,2A10,10,0,1,1,2,12,10,10,0,0,1,12,2Zm0,1.5A8.5,8.5,0,1,0,20.5,12,8.5,8.5,0,0,0,12,3.5Z",
    transform: "translate(-22631.998 -8071.999)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_8674956_ic_fluent_info_regular_icon-2",
    "data-name": "8674956_ic_fluent_info_regular_icon",
    d: "M12,14a.75.75,0,0,0,.744-.648l.007-.1,0-5.5a.75.75,0,0,0-1.494-.1l-.007.1,0,5.5A.75.75,0,0,0,12,14Zm0,3.5a1,1,0,1,0-1-1A1,1,0,0,0,12,17.5Z",
    transform: "translate(-22631.998 -8071.999)",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a349b969d8922cf5aeec5807729fb173.svg";
export { ForwardRef as ReactComponent };